import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "100",
      cy: "100",
      r: "64"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "80",
      cy: "80",
      r: "6",
      fill: "var(--mc-avatar)",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "120",
      cy: "110",
      r: "4",
      fill: "var(--mc-avatar)",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "95",
      cy: "130",
      r: "5",
      fill: "var(--mc-avatar)",
      opacity: ".45"
    }, null, -1)
  ]))]))
}
export default { render: render }